import { t } from '../../i18n/t';

/**
 * Round 137 (owner decision 9) - a learner the writing pipeline flags as struggling (`strugglingLearner`, p3StrugglingClassifier.ts) sees a
 * short supportive message and a way to reach a person. Nothing about grading, tries or completion changes; the model answer still appears
 * only after the last graded attempt (ModelAnswerPanel). "Contact support" opens the existing problem-report dialog (ProblemReporter listens
 * for OPEN_PROBLEM_REPORTER_EVENT); the learner writes in their own words.
 */
export const OPEN_PROBLEM_REPORTER_EVENT = 'emi:open-problem-reporter';

export default function StrugglingWriterNotice() {
  return (
    <div className="bg-paper-2 border border-line rounded-xl p-4" role="note" data-testid="struggling-writer-notice">
      <p className="text-body-md text-ink">{t('lesson:strugglingWriter.message')}</p>
      <button
        type="button"
        onClick={() => window.dispatchEvent(new Event(OPEN_PROBLEM_REPORTER_EVENT))}
        className="mt-2 text-sm text-amber-strong underline min-h-[44px]"
      >{t('lesson:strugglingWriter.contactSupport')}</button>
    </div>
  );
}
